import React, { useContext } from 'react';
import Button from './button';
import { AuthorContext } from '../context/author-context';
import { PageContext } from '../context/page-context';
import { canUseLocalStorage } from '../util/canuse';

const AuthActions = ({
  uiSource,
  onSignIn,
  onSignOut,
  hideSignOut,
  forcePrimary,
  cta,
  intent,
  fullWidth,
  dontExpand,
  children
}) => {
  const { author, SignOut, SignIn } = useContext(AuthorContext);
  const { logEvent } = useContext(PageContext);

  const signedOutContent = (
    <Button
      primary={forcePrimary}
      minWidth={fullWidth ? '100%' : 'auto'}
      flush
      dontExpand={dontExpand}
      onClick={() => {
        const url = typeof window !== 'undefined' && window.location.href;
        logEvent('sign_in_start', { intent, uiSource, url });
        if (canUseLocalStorage()) {
          const intendedURL = window.location.pathname;
          localStorage.setItem('INTENDED_URL', intendedURL);
          localStorage.setItem('sign_in_intent', intent);
        }
        if (onSignIn) {
          onSignIn();
        }

        SignIn();
      }}
    >
      {cta}
    </Button>
  );

  const signedInContent = (
    <>
      {children}
      {!hideSignOut && (
        <Button
          flush
          dontExpand
          onClick={() => {
            if (onSignOut) {
              onSignOut();
            }
            SignOut();
          }}
        >
          Sign Out
        </Button>
      )}
    </>
  );

  return <>{author ? signedInContent : signedOutContent}</>;
};
export default AuthActions;
